( function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller( "AttachmentRemoveModalController", AttachmentRemoveModalController);

    AttachmentRemoveModalController.$inject = ['$uibModalInstance', 'entity'];

    function AttachmentRemoveModalController( $uibModalInstance, entity ) {

        var vm = this;

        vm.attachment = entity;

        vm.close = close;
        vm.confirmRemove = confirmRemove;

        function close() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmRemove() {
            $uibModalInstance.close(true);
        }

    }
})();
